var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1a.75.75 0 0 0-.75.75v.45c-1.711.347-3 1.86-3 3.675v.44a4.5 4.5 0 0 1-1.137 2.991l-.174.195a.749.749 0 0 0 .56 1.25h9a.751.751 0 0 0 .56-1.25l-.173-.195a4.5 4.5 0 0 1-1.136-2.99v-.441a3.75 3.75 0 0 0-3-3.675v-.45A.75.75 0 0 0 7 1M8.06 12.562A1.5 1.5 0 0 0 8.5 11.5h-3a1.5 1.5 0 0 0 2.562 1.062"
  })));
};
export default SvgBell;